import { useContext } from 'react'
import { WizardContext } from '../contexts/WizardContext'
import { WizardContextValue } from '../types'

const useWizard = () => {
  return useContext(WizardContext) as WizardContextValue
}

export default useWizard
